import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import { Icon } from '@iconify/react'
import { mcpConnectionsGetService } from 'src/api/mcp-connection'
import { colors } from '../tokens'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '16px',
    padding: '16px 20px',
    background: '#FFFFFF',
    border: '1px dashed rgba(1,95,251,.4)',
    borderRadius: '12px',
  },
  icon: {
    width: 20,
    height: 20,
    flex: 'none',
    color: colors.primary,
  },
  text: {
    flex: 1,
    minWidth: 220,
  },
  title: {
    fontSize: '14px',
    fontWeight: 600,
  },
  desc: {
    marginTop: 2,
    fontSize: '13px',
    color: colors.muted,
  },
  questions: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px',
    width: '100%',
  },
  question: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    padding: '6px 12px',
    border: `1px solid ${colors.border}`,
    borderRadius: '999px',
    background: colors.hover,
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '12px',
    color: colors.navy,
    '&:hover': {
      background: colors.primarySoft,
      borderColor: 'rgba(1,95,251,.4)',
    },
  },
  connect: {
    marginLeft: 'auto',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    color: colors.primary,
  },
})

const CONNECT_PATH = '/connect'

/** Suggested questions to paste into Claude / ChatGPT (copied on click). */
const AskAiBox = ({ questions }) => {
  const classes = useStyles()
  const history = useHistory()
  const [copied, setCopied] = useState(null)
  // null until known, so the link doesn't flash for connected workspaces.
  const [connected, setConnected] = useState(null)

  useEffect(() => {
    let active = true
    mcpConnectionsGetService()
      .then(response => {
        const tools = response?.data?.tools || []
        if (active) setConnected(tools.some(tool => tool.connected))
      })
      .catch(() => active && setConnected(false))
    return () => {
      active = false
    }
  }, [])

  const copy = question => {
    navigator.clipboard?.writeText(question)
    setCopied(question)
    setTimeout(() => setCopied(null), 1500)
  }

  return (
    <div className={classes.root}>
      <Icon icon="tabler:message-circle-question" className={classes.icon} />
      <div className={classes.text}>
        <div className={classes.title}>
          Ask Claude or ChatGPT about this data
        </div>
        <div className={classes.desc}>
          Get answers instead of reading charts. Try one of these:
        </div>
      </div>
      <div className={classes.questions}>
        {questions.map(question => (
          <button
            key={question}
            type="button"
            title="Copy question"
            className={classes.question}
            onClick={() => copy(question)}
          >
            <Icon
              icon={copied === question ? 'tabler:check' : 'tabler:copy'}
              width={12}
              height={12}
            />
            {question}
          </button>
        ))}
        {connected === false && (
          <button
            type="button"
            className={classes.connect}
            onClick={() => history.push(CONNECT_PATH)}
          >
            Connect an assistant →
          </button>
        )}
      </div>
    </div>
  )
}

export default AskAiBox
